<template>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
    <DoctorStatCard
      :icon="mdiAccountCheckOutline"
      label="Situação"
      :icon-color="activeStatus.color === 'green' ? 'green' : 'grey'"
      :icon-background="activeStatus.color === 'green' ? 'bg-green-50' : 'bg-gray-100'"
      test-id="doctor-stat-situation"
    >
      <LabelBadge
        :label="activeStatus.label"
        :color="activeStatus.color"
        :icon="null"
        size="small"
      />
    </DoctorStatCard>

    <DoctorStatCard
      :icon="mdiOfficeBuildingOutline"
      label="Empresas"
      :value="companiesCount"
      icon-color="primary"
      test-id="doctor-stat-companies"
    />

    <DoctorStatCard :icon="mdiCardAccountDetailsOutline" label="CRM" test-id="doctor-stat-crm">
      <LabelBadge
        v-if="crmStatus"
        :label="crmStatus.label"
        :color="crmStatus.color"
        :icon="null"
        size="small"
      />
      <span v-else class="text-base font-bold text-gray-900">—</span>
    </DoctorStatCard>

    <DoctorStatCard
      :icon="mdiStethoscope"
      label="Especialidades"
      :value="specialtiesCount"
      icon-color="primary"
      test-id="doctor-stat-specialties"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  mdiAccountCheckOutline,
  mdiOfficeBuildingOutline,
  mdiCardAccountDetailsOutline,
  mdiStethoscope
} from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import DoctorStatCard from '../atoms/DoctorStatCard.vue'
import { getActiveStatusConfig, getCrmStatusConfig } from '../../helpers/doctorStatus'

const props = defineProps<{
  doctor: DoctorDetailResponse
}>()

// Situação agregada: ativo se houver ao menos um vínculo ativo entre as empresas.
const isActive = computed(() => props.doctor.companies.some((c) => c.isActive))
const activeStatus = computed(() => getActiveStatusConfig(isActive.value))
const companiesCount = computed(() => props.doctor.companies.length)
const crmStatus = computed(() => getCrmStatusConfig(props.doctor.doctor.mainCrm.status))
const specialtiesCount = computed(() => props.doctor.doctor.mainCrm.doctorSpecialties?.length ?? 0)
</script>
